import React from 'react'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import EmptyState from 'assets/images/auth/empty-state.png'
const TransactionHistoryContainer = styled.div`
  padding-bottom: 2.5em;
`
const TransactionCard = styled(Card)`
  border-radius: 20px;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
`
const EmptyImage = styled(Card.Img)`
  width: 5.313em;
  height: 5.313em;
`
const Title = styled.h6`
  font-weight: bold;
`
export default function TransactionHistory() {
  return (
    <TransactionHistoryContainer>
      <TransactionCard className="justify-content-md-center pb-5">
        <Title className="px-3 pt-3 pb-5">Transactions History</Title>
        <Card.Body className="text-center">
          <EmptyImage variant="bottom" src={EmptyState} />
          <h5 className="mt-3 text-muted">
            You don&apos;t have transactions yet.
          </h5>
        </Card.Body>
      </TransactionCard>
    </TransactionHistoryContainer>
  )
}
